import addressTranslations from "./addressTranslations";
import contactTranslations from "./contactTranslations";

const personTranslations = {
  gender: {
    label: "Anrede",
    values: {
      male: "Herr",
      female: "Frau",
      diverse: "Divers",
    },
  },
  givenName: {
    label: "Vorname",
  },
  familyName: {
    label: "Nachname",
  },
  nationality: {
    label: "Staatsangehörigkeit",
  },
  birthDate: {
    label: "Geburtsdatum",
  },
  beaSafeId: {
    label: "beA-Adresse",
  },
  residenceAddress: addressTranslations,
  addresses: [addressTranslations],
  ...contactTranslations,
  bankData: {
    label: "Bankverbindung Mandant",
    iban: {
      label: "IBAN",
    },
  },
};

export default personTranslations;
